import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MenuItem } from 'primeng/api';
import gsap from 'gsap';
import { AuthService } from 'src/app/core-services/auth.service';
import { UserRole, PlanSubcriptions } from 'src/app/Enum/Enum';
import { openLoginModal } from 'src/app/core-services/eventEmitter';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.module';
import { selectIsLoggedIn } from 'src/app/store/user/user.reducer';
import { filter } from 'rxjs/operators';

import * as userActions from '../../../store/user/user.actions';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  constructor(
    private router: Router,
    private authenticationService: AuthService,
    private toastr: ToastrService,
    private store: Store<AppState>,
  ) {
    router.events.pipe(
       filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        // You only receive NavigationStart events
        if (this.isMenuOpened) {
          this.toggleMenu();
        }
      });

  }

  ngOnInit() {
    this.authenticationService.IsUserAuthenticated().subscribe((res: any) => {
      if (res && !res.status) {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('planText');
        this.store.dispatch(userActions.logout());
      }
    });
    this.store.select(selectIsLoggedIn).subscribe(value => {
      this.isLoggedIn = value;

      if (!this.isLoggedIn) {
        this.isAdmin = false;
      }

      this.LoadUserAndCheckIfAdmin();
    });
  }

  LoadUserAndCheckIfAdmin() {
    const currentUser = localStorage.getItem('currentUser');

    if (currentUser) {
      this.store.dispatch(userActions.login());

      this.loggedInUser = JSON.parse(currentUser);
      this.userNameShorthand = this.GenerateUsernameShorthand(this.loggedInUser.usersDetailsVM);
      const usernameElement: any = document.querySelector('.user-avatar');
      usernameElement.style.backgroundColor = this.stringToColour(this.userNameShorthand);

      if (this.loggedInUser && this.loggedInUser.usersDetailsVM) {
        this.userName = this.loggedInUser.usersDetailsVM.firstName + ' ' + this.loggedInUser.usersDetailsVM.lastName;
        this.isSubcription = this.loggedInUser.usersDetailsVM.planSub;
        this.planId = this.loggedInUser.usersDetailsVM.planId;
        this.userId = this.loggedInUser.usersDetailsVM.id;

        if (this.loggedInUser.usersDetailsVM.userRole != null && this.loggedInUser.usersDetailsVM.userRole != '') {
          if (this.loggedInUser.usersDetailsVM.userRole == UserRole.SuperAdmin) {
            this.isAdmin = true;
          }
        }
      }
    }
  }

  GenerateUsernameShorthand(user: any): string {
    const { firstName, lastName } = user;
    let userNameShorthand;

    if (firstName && !lastName) {
      userNameShorthand = firstName.charAt(0);
    } else {
      userNameShorthand = firstName.charAt(0) + lastName.charAt(0);
    }

    return userNameShorthand;
  }

  firstName: any;
  links: any[] = [
    {
      title: 'Route Finder',
      href: '/searchresultsplash',
    },
    {
      title: 'Schedule',
      href: '/schedule',
    },
    {
      title: 'Shipment Tracker',
      href: '/voyagetrackersplash',
    }, {
      title: 'Port activities',
      href: '/portcalendarsplash'
    },
    {
      title: 'Open Cargo',
      href: '/raterequestlist'
    },
    {
      title: 'Analytics',
      href: '/analytics',
    },
    {
      title: 'Pricing',
      href: '/planselection'
    }, {
      title: 'News',
      href: '/news'
    }
    /* {
         title: 'Data Provider',
         href: '/underdevelopment',
     } */
  ]
  voyageFinderLinks: any[] = [
    {
      title: 'Search',
      href: '/searchresult',
    }, {
      title: 'Rate Requests',
      href: '/raterequestlist'
    }, {
      title: 'Booking Requests',
      href: '/bookinglist'
    }
  ]

  adminLinks: any[] = [
    {
      title: 'Import Schedule CSV',
      href: '/importschedulecsv',
    },
    {
      title: 'Shipping Lines',
      href: '/shippinglines'
    },
    {
      title: 'Port',
      href: '/ports'
    },
    {
      title: 'Vessels',
      href: '/vessels'
    },
    {
      title: 'Users',
      href: '/users'
    },
    {
      title: 'Plans',
      href: '/plans'
    },
    {
      title: "API's",
      href: '/apis'
    },
    {
      title: "Open Search Config",
      href: '/opensearch'
    }
  ]

  isLoggedIn: boolean = false;
  isAdmin: boolean;
  isSubcription: number;
  planId: number;
  userId: number;
  user: MenuItem[];
  loggedInUser: any;
  userName: string;
  userNameShorthand: string;
  isMenuOpened: boolean = false;
  isMobileDropdownOpened = false;
  openLoginModal = openLoginModal;

  // Timelines
  dropdownTl = gsap.timeline({ paused: true });
  hamburgerTl = gsap.timeline({ paused: true });
  mobileDropdownTl = gsap.timeline({ paused: true });
  userDropdownTl = gsap.timeline({ paused: true });
  adminDropdownTl = gsap.timeline({ paused: true });

  ngAfterViewInit() {
    /* For the Port-to-Port dropdown
    this.dropdownTl.to(".dropdown-list", { y: 0, duration: 0.4, opacity: 1 });
    */
    this.setUpMenuAnimations();

    /* Mobile dropdown
    this.mobileDropdownTl.to(".mobile-navigation-links-container", { y: 120, duration: 0.33 });
    this.mobileDropdownTl.to(".down-arrow", { rotation: 180, duration: 0.5 }, 0);
    this.mobileDropdownTl.to(".mobile-dropdown-link", { x: 0, opacity: 1, duration: 0.22, stagger: 0.11 }, 0);
    */
    this.userDropdownTl.to(".user-dropdown", { y: 0, duration: 0.4, opacity: 1 });
    this.adminDropdownTl.to(".admin-dropdown", { y: 0, duration: 0.4, opacity: 1 });
  }

  signOut() {
    this.store.dispatch(userActions.logout());
    this.authenticationService.logout();
    this.router.navigate(['/']);
  }

  animateLink(link) {
    const underline = link.querySelector('.underline');
    const q = link.querySelector('a');
    gsap.to(underline, { x: 0, duration: 0.33, ease: 'circ.inOut' });
    gsap.to(q, { duration: 0.33, color: '#ff9057' });
  }

  animateLinkOut(link) {
    const underline = link.querySelector('.underline');
    const q = link.querySelector('a');
    gsap.to(underline, { x: '100%', duration: 0.33, ease: 'circ.inOut' });
    gsap.set(underline, { x: '-110%', delay: 0.33 })
    gsap.to(q, { duration: 0.33, color: '#222222' });
  }

  setUpMenuAnimations() {
    const mobileNavigationLinks = document.querySelectorAll('.mobile-navigation-link');
    this.hamburgerTl.to(".first-slide", { y: 14, duration: 0.33 }, 0);
    this.hamburgerTl.to(".last-slide", { y: -14, duration: 0.33 }, 0);
    this.hamburgerTl.set(".second-slide", { opacity: 0 });
    this.hamburgerTl.to(".first-slide", { duration: 0.33, rotation: 45, ease: 'back.out' }, 0.34);
    this.hamburgerTl.to(".last-slide", { duration: 0.33, rotation: -45, ease: 'back.out' }, 0.34);
    this.hamburgerTl.to(".menu-background", { duration: 1, scale: 100, ease: 'power1.out' }, 0.34);
    this.hamburgerTl.to(mobileNavigationLinks, { duration: 0.33, opacity: 1, x: 0, stagger: 0.11 }, 0.75);
  }

  toggleMenu() {
    const menuContent: any = document.querySelector('.menu-content');

    if (!this.isMenuOpened) {
      this.hamburgerTl.play();
      menuContent.style.pointerEvents = 'all';
    }
    if (this.isMenuOpened) {
      this.hamburgerTl.reverse();
      menuContent.style.pointerEvents = 'none';

      if (this.isMobileDropdownOpened) {
        this.mobileDropdownTl.reverse();
      }
    }
    this.isMenuOpened = !this.isMenuOpened;
  }

  stringToColour(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var colour = '#';
    for (var i = 0; i < 3; i++) {
      var value = (hash >> (i * 8)) & 0xFF;
      colour += ('00' + value.toString(16)).substr(-2);
    }
    return colour;
  }

  toggleMobileDropdown() {
    if (!this.isMobileDropdownOpened) this.mobileDropdownTl.play();
    else this.mobileDropdownTl.reverse();

    this.isMobileDropdownOpened = !this.isMobileDropdownOpened;
  }

  openUserDropdown() {
    const userDropdown: any = document.querySelector('.user-dropdown');
    userDropdown.style.pointerEvents = 'all';
    this.userDropdownTl.play();
  }

  openAdminDropdown() {
    console.log('open admin dropdown');
    const adminDropdownContainer: any = document.querySelector('.admin-dropdown-container');
    adminDropdownContainer.style.pointerEvents = 'all';
    this.adminDropdownTl.play();
  }

  closeAdminDropdown() {
    const adminDropdownContainer: any = document.querySelector('.admin-dropdown-container');
    adminDropdownContainer.style.pointerEvents = 'none';
    this.adminDropdownTl.reverse();
  }

  closeUserDropdown() {
    const userDropdown: any = document.querySelector('.user-dropdown');
    userDropdown.style.pointerEvents = 'none';
    this.userDropdownTl.reverse()
  }


  planSubcriptiont(status) {
    if (this.planId > 0 && this.userId > 0 && status > 0) {
      this.authenticationService.subcriptionPlan(this.planId, this.userId).subscribe((response: any) => {
        if (response != null && response.content != null) {
          if (response.content == true) {
            this.isSubcription = status;
            if (this.isSubcription == 3) {
              this.toastr.info('Plan is subscribed successfully  ', 'Info');
            }
            else {
              this.toastr.info('Plan is unsubscribed successfully', 'Info');
            }
            if (PlanSubcriptions.Active == status) {
              this.isSubcription = PlanSubcriptions.Suspended;
              this.loggedInUser.planSub = PlanSubcriptions.Suspended;;
            }
            else if (PlanSubcriptions.Suspended) {
              this.isSubcription = PlanSubcriptions.Active;;
              this.loggedInUser.planSub = PlanSubcriptions.Active;;
            }

            localStorage.setItem("currentUser", JSON.stringify(this.loggedInUser));
          }
          else {
            this.toastr.error('Something wrong', 'Error');
          }
        }
      });
    }
  }
}
